import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import { NAVIGATE_AUTH, NAVIGATE_ADMIN } from '../constant';
import { PermissionProvider } from '../providers/PermissionProvider';
import { SettingsProvider } from '../providers/SettingsProvider';
const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));

const AppRoute = () => {
    return (
        <Suspense fallback={<LoaderText />}>
            <Routes>
                <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />}></Route>
                <Route path={`${NAVIGATE_ADMIN.ADMIN}/*`} element={<SettingsProvider> <PermissionProvider> <AdminRoute /> </PermissionProvider></SettingsProvider>}></Route>
                <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                <Route path='*' element={<GuestRoute />}></Route>
            </Routes>
        </Suspense>
    )
}

export default AppRoute